import React from "react";

type RoadmapStatus = "available" | "progress" | "upcoming";

const map: Record<RoadmapStatus, { label: string; color: string; emoji: string }> = {
  available: { label: "Disponible", color: "text-green-400", emoji: "🟢" },
  progress: { label: "En développement", color: "text-yellow-400", emoji: "🟡" },
  upcoming: { label: "À venir", color: "text-gray-300", emoji: "⚪" },
};

export function RoadmapBadge({ status }: { status: RoadmapStatus }) {
  const conf = map[status];
  return (
    <span className={`text-sm font-medium flex items-center gap-1 ${conf.color}`}>
      {conf.emoji} {conf.label}
    </span>
  );
}
